import { IAction, IState, defaultContextValues } from './UseNewOffsiteCampaignContext';

export type ActionTypes =
  | 'CLEAR_ERROR'
  | 'CREATE_CAMPAIGN_FAILED'
  | 'RESET_WIZARD'
  | 'SET_NAME_VALUE'
  | 'SET_STATE_VALUE'
  | 'SET_START_DATE_VALUE'
  | 'SET_END_DATE_VALUE'
  | 'SET_SELECTED_FEATURE_VALUE'
  | 'SET_MINIMUM_BROWSE_TIME'
  | 'UPDATE_STEP_VALID'
  | 'UPDATE_VALID_STEPS'
  | 'UPDATE_CAMPAIGN'
  | 'UPDATE_LOOKBACK_PERIOD';

export function NewOffsiteCampaignReducer(state: IState, action: IAction) {
  const { payload } = action;
  let newState: IState = null;

  switch (action.type) {
    case 'CLEAR_ERROR':
      newState = {
        ...state,
        error: false,
      };
      break;
    case 'CREATE_CAMPAIGN_FAILED':
      newState = {
        ...state,
        success: payload.success,
        createdCampaign: payload.createdCombinedCampaign,
        error: payload.error,
        errorMessage: payload.errorMessage,
      };
      break;
    case 'RESET_WIZARD':
      newState = { ...defaultContextValues };
      break;
    case 'SET_NAME_VALUE':
      newState = {
        ...state,
        campaign: {
          ...state.campaign,
          name: payload.name,
        },
      };

      break;
    case 'SET_STATE_VALUE':
      newState = {
        ...state,
        campaign: {
          ...state.campaign,
          state: payload.state,
        },
      };

      break;
    case 'SET_START_DATE_VALUE':
      const offsiteStartTime =
        payload.startTime !== undefined && payload.startTime !== null ? payload.startTime.valueOf() : undefined;

      newState = {
        ...state,
        campaign: {
          ...state.campaign,
          startTime: offsiteStartTime,
        },
      };

      break;
    case 'SET_END_DATE_VALUE':
      const offsiteEndTime =
        payload.endTime !== undefined && payload.endTime !== null ? payload.endTime.valueOf() : undefined;
      newState = {
        ...state,
        campaign: {
          ...state.campaign,
          endTime: offsiteEndTime,
        },
      };

      break;
    case 'SET_MINIMUM_BROWSE_TIME':
      newState = {
        ...state,
        campaign: {
          ...state.campaign,
          minimumBrowseTime: payload.minimumBrowseTime,
        },
      };
      break;
    case 'UPDATE_LOOKBACK_PERIOD':
      newState = {
        ...state,
        campaign: {
          ...state.campaign,
          lookbackPeriod: payload.lookbackPeriod,
        },
      };
      break;
    case 'SET_SELECTED_FEATURE_VALUE':
      newState = {
        ...state,
        campaign: {
          ...state.campaign,
          type: payload.type,
        },
      };
      break;
    case 'UPDATE_CAMPAIGN':
      newState = {
        ...state,
        campaign: payload.campaign,
      };
      break;
    case 'UPDATE_STEP_VALID':
      newState = {
        ...state,
        stepValid: payload.stepValid,
      };
      break;
    case 'UPDATE_VALID_STEPS':
      newState = {
        ...state,
        validSteps: payload.validSteps,
      };
      break;
    default: {
      throw new Error(`Unhandled action type: ${action.type}`);
    }
  }

  return newState;
}
